/*
  C11: fill Froonze's collection wishlist buttons in after Broadcast's AJAX grid updates.

  Broadcast's filter/sort (collection-filters-form.js) replaces [data-products-grid]'s innerHTML
  wholesale, and infinite scroll (ajaxinate.js) appends new .grid-item nodes inside it; neither
  dispatches an event this theme can listen for, so the new cards' placeholders have to be
  noticed by observing the DOM. Froonze exposes one public hook for filling them,
  window.frcp.wishlist.attachOnCollection().

  IMPORTANT -- why this observer must not fire on every mutation:
  Froonze's attachOnCollection() fills each placeholder with `placeholder.innerHTML = <button>`,
  which is itself a childList mutation *inside the subtree being observed*. Reacting to any
  mutation therefore re-triggers the hook, which mutates again, forever -- a self-sustaining
  loop that rebuilt every heart roughly every 150ms. Because each rebuild is a brand new element,
  a hovered heart restarted its scale transition from 1 every cycle and visibly pulsed.

  So the trigger is a precise question rather than "did anything change": is there a placeholder
  that Froonze has NOT filled yet? A filled placeholder contains .frcp-wishlist-btn; a freshly
  server-rendered one is empty. Once the hook has filled them all the answer is no, so the
  reaction terminates instead of feeding itself. New AJAX cards arrive unfilled, answer yes once,
  and are filled once.
*/
(function () {
  var containers = document.querySelectorAll('[data-products-grid]');
  if (!containers.length) return;

  var pending = null;

  function hasUnfilledPlaceholder() {
    var placeholders = document.querySelectorAll('.frcp-wishlist-grid-btn-wrapper');
    for (var i = 0; i < placeholders.length; i++) {
      if (!placeholders[i].querySelector('.frcp-wishlist-btn')) return true;
    }
    return false;
  }

  function fillNewPlaceholders() {
    pending = null;
    if (!hasUnfilledPlaceholder()) return;
    if (window.frcp && frcp.wishlist && typeof frcp.wishlist.attachOnCollection === 'function') {
      frcp.wishlist.attachOnCollection();
    }
  }

  var observer = new MutationObserver(function () {
    if (pending || !hasUnfilledPlaceholder()) return;
    pending = setTimeout(fillNewPlaceholders, 150);
  });

  containers.forEach(function (container) {
    observer.observe(container, { childList: true, subtree: true });
  });
})();
